/* AlienGuards V5 "next level" polish. Visual only: never changes form values, prices, properties or cart calls.
   - builder: sliding green bar under the step tabs, green ring that glides to the picked option,
     price tick, segmented progress, live photo preview for the picked color, sticky build summary
   - PDP story: pinned photo that turns and swaps as the 3 lines scroll past
   - compare: sticky header state + phone model strip highlight
   Respects prefers-reduced-motion (no glides, no count-up, no scroll-linked motion). */
(function () {
  'use strict';
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function vis(e) { return !!(e && e.getClientRects().length && e.offsetWidth); }

  /* header height for sticky offsets */
  function setHH() {
    var h = $('.ag-header-section') || $('.ag-header');
    if (h) document.documentElement.style.setProperty('--ag-hh', Math.round(h.getBoundingClientRect().height) + 'px');
  }
  setHH(); addEventListener('resize', setHH, { passive: true });

  /* ---------- builder ---------- */
  function Builder(b) {
    this.b = b; this.form = b.closest('form') || document;
    this.tabs = $('.ag-tabs', b);
    if (!this.tabs || this.tabs.__agNext) return;
    this.tabs.__agNext = 1;
    var self = this;
    // 1. moving bar
    this.ink = document.createElement('i');
    this.ink.className = 'ag-tabs__ink no-anim'; this.ink.setAttribute('aria-hidden', 'true');
    this.tabs.appendChild(this.ink);
    // 2. progress segments
    var txt = $('.ag-sumbar__txt', b.parentNode) || $('.ag-sumbar__txt');
    this.tabList = $$('.ag-tab', this.tabs);
    if (txt && this.tabList.length > 1) {
      this.prog = document.createElement('div'); this.prog.className = 'ag-prog'; this.prog.setAttribute('aria-hidden', 'true');
      this.tabList.forEach(function () { self.prog.appendChild(document.createElement('i')); });
      txt.appendChild(this.prog);
    }
    this.tot = $('.ag-sumbar__tot', b.parentNode) || $('.ag-sumbar__tot');
    this.small = txt && $('small', txt);
    this.picks = $('[data-ag-sticky-picks]');
    this.lastColor = null; this.lastTot = this.tot ? this.tot.textContent : '';
    this.rings = [];
    this.sync(true);
    setTimeout(function () { self.ink.classList.remove('no-anim'); }, 60);
    new MutationObserver(function () { self.queue(); }).observe(b, { attributes: true, subtree: true, attributeFilter: ['aria-selected', 'hidden', 'class'] });
    if (this.tot) new MutationObserver(function () { self.onTot(); }).observe(this.tot, { childList: true, characterData: true, subtree: true });
    if (this.small) new MutationObserver(function () { self.onPicks(); }).observe(this.small, { childList: true, characterData: true, subtree: true });
    b.addEventListener('change', function (e) { self.onChange(e); });
    addEventListener('resize', function () { self.queue(true); }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.queue(true); });
    this.onPicks();
  }
  Builder.prototype.queue = function (noAnim) {
    var self = this; if (this.q) return; this.q = 1;
    raf(function () { self.q = 0; self.sync(noAnim); });
  };
  Builder.prototype.sync = function (noAnim) {
    var self = this, sel = $('.ag-tab[aria-selected=true]', this.tabs), idx = this.tabList.indexOf(sel);
    if (sel) {
      var tr = this.tabs.getBoundingClientRect(), r = sel.getBoundingClientRect();
      if (noAnim) this.ink.classList.add('no-anim');
      this.ink.style.width = r.width + 'px';
      this.ink.style.transform = 'translateX(' + (r.left - tr.left + this.tabs.scrollLeft) + 'px)';
      if (noAnim) { this.ink.offsetWidth; this.ink.classList.remove('no-anim'); }
    }
    if (this.prog) $$('i', this.prog).forEach(function (e, i) { e.classList.toggle('is-on', i <= idx || self.tabList[i].classList.contains('is-done')); });
    this.ringAll(noAnim);
  };
  /* radio groups get one ring that glides between options */
  Builder.prototype.groups = function () {
    var out = [];
    $$('.ag-cards, .ag-choices, .ag-swatches', this.b).forEach(function (g) {
      if (!g.querySelector('input[type=radio]')) return; // checkbox groups keep their own per-option state
      out.push(g);
    });
    return out;
  };
  Builder.prototype.ringAll = function (noAnim) {
    var self = this;
    this.groups().forEach(function (g) { self.ring(g, noAnim); });
  };
  Builder.prototype.ring = function (g, noAnim) {
    var ring = g.__agRing;
    if (!ring) {
      ring = g.__agRing = document.createElement('i');
      ring.className = 'ag-selring no-anim'; ring.setAttribute('aria-hidden', 'true');
      if (g.classList.contains('ag-swatches')) ring.classList.add('ag-selring--dot');
      g.insertBefore(ring, g.firstChild);
      g.classList.add('has-ring');
      noAnim = true;
    }
    var inp = g.querySelector('input[type=radio]:checked');
    if (!inp || !vis(g)) { ring.classList.remove('is-on'); g.__agPrev = null; return; }
    var opt = inp.closest('.ag-cardopt, .ag-choice, .ag-swatch');
    var target = g.classList.contains('ag-swatches') ? (opt && opt.querySelector('.ag-swatch__dot')) : opt;
    if (!target || !vis(target)) { ring.classList.remove('is-on'); return; }
    var gr = g.getBoundingClientRect(), r = target.getBoundingClientRect(), pad = g.classList.contains('ag-swatches') ? 5 : 0;
    var first = !ring.classList.contains('is-on');
    if (noAnim || first || RM) ring.classList.add('no-anim');
    ring.style.width = (r.width + pad * 2) + 'px';
    ring.style.height = (r.height + pad * 2) + 'px';
    ring.style.transform = 'translate(' + (r.left - gr.left - pad) + 'px,' + (r.top - gr.top - pad) + 'px)';
    if (getComputedStyle(target).borderRadius) ring.style.borderRadius = pad ? '50%' : getComputedStyle(target).borderRadius;
    ring.classList.add('is-on');
    ring.offsetWidth;
    if (!RM) ring.classList.remove('no-anim');
  };
  Builder.prototype.onChange = function (e) {
    var t = e.target; if (!t || !t.name) return;
    this.queue();
    // live preview: show the stage photo for the picked base color (only photos that already exist)
    var f = t.closest('[data-field], .ag-field');
    var isColor = /base_color|base color/i.test((f && (f.getAttribute('data-field') || f.id || '')) + ' ' + t.name);
    if (isColor && t.checked && typeof window.agGalleryShow === 'function') {
      var v = (t.value || '').toLowerCase().trim();
      if (v && v !== this.lastColor) { this.lastColor = v; window.agGalleryShow(v); }
    }
  };
  Builder.prototype.onTot = function () {
    var now = this.tot.textContent, self = this;
    if (now === this.lastTot || now === this.wrote) return;
    var from = parse(this.lastTot), to = parse(now); this.lastTot = now;
    var els = [this.tot].concat($$('[data-ag-sticky-total], [data-ag-live-price]'));
    els.forEach(function (e) { e.classList.remove('is-tick'); e.offsetWidth; e.classList.add('is-tick'); });
    clearTimeout(this.tk); this.tk = setTimeout(function () { els.forEach(function (e) { e.classList.remove('is-tick'); }); }, 650);
    if (RM || isNaN(from) || isNaN(to) || from === to) return;
    // short count-up on the summary total only (the real text is restored at the end)
    var t0 = performance.now(), dur = 380, el = this.tot, fmt = now;
    this.counting = 1;
    (function step(t) {
      var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3), v = from + (to - from) * e;
      if (self.lastTot !== fmt) return;
      self.wrote = k < 1 ? fmt.replace(/[\d.,]+/, v.toFixed(2)) : fmt; el.textContent = self.wrote; self.lastTot = fmt;
      if (k < 1) raf(step); else self.counting = 0;
    })(t0);
  };
  Builder.prototype.onPicks = function () {
    if (!this.picks || !this.small) return;
    var s = (this.small.textContent || '').trim();
    if (s) this.picks.textContent = s;
  };
  function parse(s) { var m = String(s || '').replace(/,/g, '').match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : NaN; }

  function initBuilders() {
    $$('.ag-builder').forEach(function (b) { if ($('.ag-tabs', b)) new Builder(b); });
  }
  initBuilders();
  var bwait = $('.ag-builder');
  if (bwait && !$('.ag-tabs', bwait)) {
    var mo = new MutationObserver(function () { if ($('.ag-tabs', bwait)) { mo.disconnect(); initBuilders(); } });
    mo.observe(bwait, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  /* ---------- PDP story ---------- */
  var story = $('[data-ag-story]');
  if (story) {
    var beats = $$('.ag-story__beat', story), imgs = $$('.ag-story__img', story), cur = -1;
    function setBeat(i) {
      if (i === cur) return; cur = i;
      beats.forEach(function (b, j) { b.classList.toggle('is-on', j === i); });
      if (imgs.length > 1) imgs.forEach(function (im, j) { var on = j === Math.min(i, imgs.length - 1); im.classList.toggle('is-on', on); im.classList.toggle('is-off', !on); });
    }
    setBeat(0);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (x) { if (x.isIntersecting) setBeat(beats.indexOf(x.target)); });
      }, { rootMargin: (matchMedia('(max-width: 989px)').matches ? '-38% 0px -40% 0px' : '-45% 0px -45% 0px'), threshold: 0 });
      beats.forEach(function (b) { io.observe(b); });
    }
    if (!RM && imgs.length) {
      var ticking = 0;
      function spin() {
        ticking = 0;
        var r = story.getBoundingClientRect(), h = r.height - innerHeight;
        var p = h > 0 ? Math.max(0, Math.min(1, -r.top / h)) : 0;
        story.style.setProperty('--st-r', ((p - 0.5) * 8).toFixed(2) + 'deg');
        story.style.setProperty('--st-s', (1 + p * 0.06).toFixed(3));
      }
      addEventListener('scroll', function () { if (!ticking) { ticking = 1; raf(spin); } }, { passive: true });
      spin();
    }
  }

  /* ---------- compare: sticky header + phone strip ---------- */
  var cmp = $('[data-ag-cmp]');
  if (cmp && 'IntersectionObserver' in window) {
    var thead = $('thead', cmp);
    if (thead) {
      var sent = document.createElement('div'); sent.style.cssText = 'height:1px;margin-top:-1px'; sent.setAttribute('aria-hidden', 'true');
      cmp.parentNode.insertBefore(sent, cmp);
      new IntersectionObserver(function (es) {
        es.forEach(function (x) { cmp.classList.toggle('is-stuck', !x.isIntersecting && x.boundingClientRect.top < 0); });
      }, { rootMargin: '-90px 0px 0px 0px' }).observe(sent);
    }
  }
  var nav = $('[data-ag-cmpnav]');
  if (nav && 'IntersectionObserver' in window) {
    var links = $$('a', nav);
    var io2 = new IntersectionObserver(function (es) {
      es.forEach(function (x) {
        if (!x.isIntersecting) return;
        links.forEach(function (a) { a.classList.toggle('is-cur', a.getAttribute('href') === '#' + x.target.id); });
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    links.forEach(function (a) {
      var t = document.getElementById((a.getAttribute('href') || '').slice(1)); t && io2.observe(t);
      a.addEventListener('click', function (e) {
        var t2 = document.getElementById(a.getAttribute('href').slice(1)); if (!t2) return;
        e.preventDefault(); t2.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }
})();
